
 const DOCUMENT_FIELDS = [
    "certificateofIncorporation",
    "memorandumofAssociation",
    "articlesofAssociation",
    "powerofAttorney",
    "copyofPANAllotment",
    "copyofTelephoneBill",
    "gSTRegistrationCopy",
    "balanceSheet",
  ];
  export const DynamicFieldRules = DOCUMENT_FIELDS.flatMap((doc) => {
    const upload = `${doc}_upload`;
    const download = `${doc}_download`;
    const remove = `${doc}_remove`;
  
    return [
      {
        form: "kycDocument",
        target: upload,
        dependsOn: [doc, `kycDocument.${doc}`],
        formula: (data) => {
          const checkbox = data[doc];
      
          const file =
            data[`kycDocument.${doc}`] ||
            data[doc] ||
            {};
      
          const hasFile =
            file?.id ||
            file?.fileId ||
            file?.fileName ||
            file?.filePath;
      
          // ✅ show upload ONLY when checked but no file
          return checkbox === true && !hasFile;
        },
      },
      
  
      {
        form: "kycDocument",
        target: download,
        dependsOn: [doc, `kycDocument.${doc}`],
        formula: (data) => {
          const checkbox = data[doc];
      
          const file =
            data[`kycDocument.${doc}`] ||
            data[doc] ||
            {};
      
          const hasFile =
            file?.id ||
            file?.fileId ||
            file?.fileName ||
            file?.filePath;
      
          return checkbox === true && !!hasFile;
        },
      },
      
      
      
      {
        form: "kycDocument",
        target: remove,
        dependsOn: [doc, `kycDocument.${doc}`],
        formula: (data) => {
          const checkbox = data[doc];
      
          const file =
            data[`kycDocument.${doc}`] ||
            data[doc] ||
            {};
      
          const hasFile =
            file?.id ||
            file?.fileId ||
            file?.fileName ||
            file?.filePath;
      
          return checkbox === true && !!hasFile;
        },
      },   
    ];
  });
  
  